import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'

interface DetailsStateProps {
  open: boolean
}

interface DetailsStateReturn extends DetailsStateProps {
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
  isOpenBlocked?: boolean
}

/**
 * State hook providing a single place to control the `open` attribute.
 * It is used internally by the `Details` component itself while still
 * being completely controllable from any parent component.
 */
export const useDetailsState = (props: DetailsStateProps): DetailsStateReturn => {
  const [open, setOpen] = useState(props.open)

  return {
    open,
    setOpen,
  }
}

/**
 * `details` element with observer bound to the `open` attribute.
 */
export const Details: React.FC<React.HTMLAttributes<HTMLDetailsElement> & DetailsStateReturn> = ({
  setOpen,
  isOpenBlocked,
  ...props
}) => {
  const detailsEl = useRef<HTMLDetailsElement>(null)

  // Listen for changed to the `open` attribute, calling `setOpen` when it changes.
  useEffect(() => {
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.attributeName === 'open') {
          setOpen(detailsEl.current!.open)
        }
      }
    })

    observer.observe(detailsEl.current!, {
      attributes: true,
      childList: false,
      subtree: false,
      attributeFilter: ['open'],
    })

    return () => observer.disconnect()
  }, [setOpen])

  //a function that block details from opening
  const blockOpen = (e: React.MouseEvent<HTMLDetailsElement, MouseEvent>) => {
    if (isOpenBlocked) {
      e.preventDefault()
      // e.stopPropagation()
    }
  }

  return <StyledDetails ref={detailsEl} {...props} onClick={blockOpen} />
}

const StyledDetails = styled.details`
  summary {
    list-style: none;
    cursor: pointer;
  }
`
